import { defineComponent as _defineComponent } from 'vue'
import Breadcrumbs from "@/components/ui/Breadcrumbs.vue";
  import Cleave from "vue-cleave-component";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { computed, onMounted, reactive } from "vue";
  import router from "@/router";
  import store from "@/store";
  import {
    email,
    helpers,
    required,
    minLength,
    numeric,
  } from "@vuelidate/validators";
  import { validPhoneNumber } from "@/helpers/validation";
  import useVuelidate from "@vuelidate/core";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { HolderType } from "@/enums/InitialHoldHolderType";

  const PLEASE_SELECT = "Please select";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'LeadUpdate',
  setup(__props, { expose: __expose }) {
  __expose();

  const leadId = computed(() => router.currentRoute.value.params.id);
  const crumbs = [
    { label: "Lead Details", path: `/leads/${leadId.value}` },
    {
      label: "Edit lead",
    },
  ];
  const form = reactive({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    postcode: "",
    holderType: PLEASE_SELECT as HolderType | string,
  });
  const rules = computed(() => {
    return {
      firstName: { required, $autoDirty: true },
      email: { required, email, $autoDirty: true },
      phone: {
        validPhoneNumber: form.phone
          ? helpers.withMessage("Invalid Phone", validPhoneNumber)
          : true,
        $autoDirty: true,
      },
      postcode: { numeric, minLength: minLength(4) },
      holderType: {},
    };
  });
  const v$ = useVuelidate(rules, form);

  onMounted(() => {
    getLead();
  });

  const getLead = () => {
    store.dispatch("contact/getLead", leadId.value).then((res) => {
      form.firstName = res.data.firstName;
      form.lastName = res.data.lastName;
      form.email = res.data.email;
      form.phone = res.data.phone;
      form.postcode =
        "postcode" in res.data ? res.data.postcode : res.data.state;
      form.holderType = res.data.holderType ?? PLEASE_SELECT;
    });
  };

  const save = async () => {
    v$.value.$touch();

    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    const { holderType, ...data } = form;

    const payload =
      holderType === PLEASE_SELECT ? data : { ...data, holderType };

    store
      .dispatch("contact/updateLead", { id: leadId.value, data: payload })
      .then(() => {
        router.push({ name: "LeadDetails", params: { id: leadId.value } });
      });
  };

const __returned__ = { leadId, crumbs, PLEASE_SELECT, form, rules, v$, getLead, save, Breadcrumbs, get Cleave() { return Cleave }, DropDown, computed, onMounted, reactive, get router() { return router }, get store() { return store }, get email() { return email }, get helpers() { return helpers }, get required() { return required }, get minLength() { return minLength }, get numeric() { return numeric }, get validPhoneNumber() { return validPhoneNumber }, get useVuelidate() { return useVuelidate }, get phoneNumberOption() { return phoneNumberOption }, get HolderType() { return HolderType } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})